export const ROOM_SESSION_KEY = 'page-spy-room';
